import "./News.scss";

import React, { memo } from "react";
import { Spinner } from "react-bootstrap";

const NewsLoader: React.FC = memo(() => {
  return (
    <div className="news-loader">
      <Spinner animation="border" />
    </div>
  );
});

export { NewsLoader };
